import React from "react";

const ChallengeItem = ({ title, description, isLast = false }) => (
  <div className="flex relative pl-8 pb-16"> 
    <div className="absolute left-0 top-[13px] bottom-0 w-2">
      <div className="absolute top-0 w-2 h-2 bg-gray-900 border border-gray-900"></div>
      {!isLast && (
        <div 
          className="absolute left-[3.5px] top-[8px] w-px bg-gray-400" 
          style={{ height: 'calc(100% - 0px)' }} 
        ></div>
      )}
    </div>
    <div className="flex-grow">
      <p 
        className="
          text-current mb-1 w-full
          font-uber text-[18px] font-medium leading-normal
          transition duration-200 ease-in-out
        "
      >
        {title}
      </p>
      <p 
        className="
          text-gray-600 
          font-uber text-base font-normal leading-normal
        "
      >
        {description}
      </p>
    </div>
  </div>
);


export default function Challenges() {
  return (
    <section className="relative w-full overflow-hidden bg-white text-gray-900">
      <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4"> 
        
        <div className="mb-12">
          <h1 
            className="
              w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
              transition duration-200 ease-in-out
            "
          >
            Key
          </h1>
          <h1 
            className="
              w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
              transition duration-200 ease-in-out
            "
          >
            Challenges Faces
          </h1>
        </div>
        
        <div className="flex flex-col xl-custom:flex-row gap-12 mb-12 xl-custom:items-start"> 

          <div className="w-full xl-custom:w-1/2 flex items-stretch justify-center order-1 xl-custom:order-2">
            <div className="w-full flex items-center justify-center rounded-lg p-4 sm:p-8">
                <img
                src="/uploads/CaseStudy/Asset 85.svg"
                className="w-full" 
                alt="Challenge visualization placeholder" />
            </div>
          </div>
          
          <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-1">
            <ChallengeItem title="Low Engagement with Traditional Ads" description="Users often skipped or ignored static ads, leading to lower conversion rates." />
            <ChallengeItem title="Short Attention Spans" description="The digital audience tends to have limited attention spans, making it difficult to hold their interest." />
            <ChallengeItem title="Lack of Personalization" description="Customers preferred experiences tailored to their preferences rather than generic content." />
            <ChallengeItem title="Technical Complexity" description="Developing seamless and responsive interactive experiences across different devices and platforms." isLast={true} />
          </div>
          
        </div>
        
        <div className="w-full h-px bg-black mt-12 mb-12"></div>
        
        <div className="flex flex-col xl-custom:flex-row mb-4">
            
            <div className="w-full xl-custom:w-1/2 hidden xl-custom:block"></div>
            <div className="w-full xl-custom:w-1/2 xl-custom:text-left xl-custom:pl-8">
              <h2 
                className="
                  w-full
                  font-uber text-[28px] font-bold leading-[36px] text-current
                  sm:text-[32px] sm:leading-[40px]
                  xl-custom:text-[36px] xl-custom:leading-[44px]
                  transition duration-200 ease-in-out
                "
              >
                What
              </h2>
              <h2 
                className="
                  w-full
                  font-uber text-[28px] font-bold leading-[36px]
                  sm:text-[32px] sm:leading-[40px]
                  xl-custom:text-[36px] xl-custom:leading-[44px]
                  transition duration-200 ease-in-out
                "
              >
                Customers Liked
              </h2>
            </div>
        </div>

        <div className="flex flex-col xl-custom:flex-row gap-12">
          
          <div className="w-full xl-custom:w-1/2 flex items-center justify-center order-1 xl-custom:order-1">
            <div className="w-full xl-custom:w-5/6 flex xl-custom:items-start justify-center rounded-lg">
                <img
                src="/uploads/CaseStudy/Asset 93.svg"
                className="w-full object-cover" 
                alt="Customer feedback visualization placeholder" />
            </div>
          </div>
          
          <div className="w-full xl-custom:w-1/2 order-2 xl-custom:order-2">
            
            <ChallengeItem title="Interactivity" description="Users appreciated the ability to engage with the content actively rather than passively consuming information." />
            <ChallengeItem title="Personalized Experience" description="Tailoring playables based on user preferences resulted in higher engagement and satisfaction." />
            <ChallengeItem title="Entertainment Value" description="The gamified elements made the experience enjoyable, increasing brand affinity." />
            <ChallengeItem title="Seamless Integration" description="The smooth, responsive experience across devices enhanced accessibility and usability." isLast={true} />
            
          </div>
          
        </div>
      </div>
    </section>
  );
}